/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Allocation_Form_Allocatee_Type_MemberInputs */

const en_admin_allocation_form_allocatee_type_member = /** @type {(inputs: Admin_Allocation_Form_Allocatee_Type_MemberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Member`)
};

const de_admin_allocation_form_allocatee_type_member = /** @type {(inputs: Admin_Allocation_Form_Allocatee_Type_MemberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mitglied`)
};

const es_admin_allocation_form_allocatee_type_member = /** @type {(inputs: Admin_Allocation_Form_Allocatee_Type_MemberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Miembro`)
};

const fr_admin_allocation_form_allocatee_type_member = /** @type {(inputs: Admin_Allocation_Form_Allocatee_Type_MemberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Membre`)
};

/** @type {(inputs: Admin_Allocation_Form_Allocatee_Type_MemberInputs) => LocalizedString} */
const it_admin_allocation_form_allocatee_type_member = en_admin_allocation_form_allocatee_type_member;

/** @type {(inputs: Admin_Allocation_Form_Allocatee_Type_MemberInputs) => LocalizedString} */
const pt_br2_admin_allocation_form_allocatee_type_member = en_admin_allocation_form_allocatee_type_member;

/** @type {(inputs: Admin_Allocation_Form_Allocatee_Type_MemberInputs) => LocalizedString} */
const pl_admin_allocation_form_allocatee_type_member = en_admin_allocation_form_allocatee_type_member;

/** @type {(inputs: Admin_Allocation_Form_Allocatee_Type_MemberInputs) => LocalizedString} */
const hu_admin_allocation_form_allocatee_type_member = en_admin_allocation_form_allocatee_type_member;

/** @type {(inputs: Admin_Allocation_Form_Allocatee_Type_MemberInputs) => LocalizedString} */
const ro_admin_allocation_form_allocatee_type_member = en_admin_allocation_form_allocatee_type_member;

/**
* | output |
* | --- |
* | "Member" |
*
* @param {Admin_Allocation_Form_Allocatee_Type_MemberInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_allocation_form_allocatee_type_member = /** @type {((inputs?: Admin_Allocation_Form_Allocatee_Type_MemberInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Allocation_Form_Allocatee_Type_MemberInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_allocation_form_allocatee_type_member(inputs)
	if (locale === "de") return de_admin_allocation_form_allocatee_type_member(inputs)
	if (locale === "es") return es_admin_allocation_form_allocatee_type_member(inputs)
	if (locale === "fr") return fr_admin_allocation_form_allocatee_type_member(inputs)
	if (locale === "it") return it_admin_allocation_form_allocatee_type_member(inputs)
	if (locale === "pt-BR") return pt_br2_admin_allocation_form_allocatee_type_member(inputs)
	if (locale === "pl") return pl_admin_allocation_form_allocatee_type_member(inputs)
	if (locale === "hu") return hu_admin_allocation_form_allocatee_type_member(inputs)
	return ro_admin_allocation_form_allocatee_type_member(inputs)
});
export { admin_allocation_form_allocatee_type_member as "admin.allocation_form.allocatee_type_member" }